import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { RoutingModule } from './routing.module';
import { FileDropModule } from 'ngx-file-drop';

import { AuthService } from './services/auth.service';
import { AuthGuardService } from './services/auth-guard.service';
import { CanDeactivateGuard } from './services/can-deactivate-guard.service';
import { CandidateService } from './services/candidate.service';
import { CommonService } from './services/common.service';
import { CompanyService } from './services/company.service';
import { JobService } from './services/job.service';
import { PhoneNumberValidator } from './validators/phone-validator.component';
import { TokenInterceptor } from './interceptors/token-interceptor.component';

import { GroupByPipe } from './filters/group-by.pipe';
import { ShortNumPipe } from './filters/short-number.pipe';
import { PhonePipe } from './filters/phone.pipe';

import { LayoutMainComponent } from './layouts/main/layout.main.component';

import { AvailabilitySelectorComponent } from './components/common/availabilitySelector/availabilitySelector.component';
import { AccountComponent } from './components/account/account.component';
import { CandidateDetailComponent } from './components/candidate/candidate-detail.component';
import { DismissCandidateComponent } from './components/common/dismissCandidate/dismissCandidate.component';
import { FormErrorComponent } from './components/common/formError/formError.component';
import { JobComponent } from './components/job/job.component';
import { JobAddComponent } from './components/job/add.component';
import { LoginComponent } from './components/login/login.component';
import { MyRecruiterComponent } from './components/common/myRecruiter/myRecruiter.component';
import { NavmenuComponent } from './components/common/navmenu/navmenu.component';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { RequestInterviewComponent } from './components/common/requestInterview/requestInterview.component';
import { ToolService } from './services/tool.service';
import { ActivateAccountModalComponent } from './components/login/activate-account-modal.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';

@NgModule({
  declarations: [
    AccountComponent,
    AppComponent,
    AvailabilitySelectorComponent,
    CandidateDetailComponent,
    DismissCandidateComponent,
    FormErrorComponent,
    GroupByPipe,
    JobComponent,
    JobAddComponent,
    LayoutMainComponent,
    LoginComponent,
    MyRecruiterComponent,
    NavmenuComponent,
    PdfViewerComponent,
    PhoneNumberValidator,
    PhonePipe,
    RequestInterviewComponent,
    ShortNumPipe,
    ActivateAccountModalComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FileDropModule,
    FormsModule,
    HttpClientModule,
    RoutingModule,
    BrowserAnimationsModule,
    MaterialModule
  ],
  entryComponents: [ActivateAccountModalComponent],
  providers: [
    AuthService,
    AuthGuardService,
    CanDeactivateGuard,
    CandidateService,
    CompanyService,
    CommonService,
    JobService,
    ToolService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts